import React, { useState, useEffect, useContext, useMemo } from "react";
import grievancess from "../../assets/img/gmbf grievance img.png";
import "./index.scss";
import GrievanceForm from "./form";
import { useParams } from "react-router-dom";
import GrievanceResForm from "./verifyForm";
import Breadcrumbs from "../../common/breadcumb";
import { TabTitle } from "../../common/dynamicTitle";
import { LangContext } from "../../context/LangContext";
function Grievance() {
  const { state } = useContext(LangContext);
  const nep = state.np;
  const pageTitle = useMemo(
    () => (nep ? "गुहेश्वरी गुनासो" : "Gmbf grievance"),
    [nep]
  );
  TabTitle(`GMBF | ${pageTitle}`);
  const { slug } = useParams();
  return (
    <>
      <Breadcrumbs PageTitle={pageTitle} />
      <div className="InSidepageSection">
        <div className="wrapper">
          <div className="grivance">
            <div className="grivance-image">
              <img src={grievancess} alt="GMBF" />
            </div>
            <div className="grivance-form">
              {
                {
                  "gmbf-grievance": (
                    <GrievanceForm nep={nep} PageTitle={pageTitle} />
                  ),
                  "grievance-rest-form": (
                    <GrievanceResForm nep={nep} PageTitle={pageTitle} />
                  ),
                }[slug]
              }
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Grievance;
